import apiHeader from "../apiHeader";
import api from "../axiosService";

export const getExamsList = async (payload) => {
    const res = await api.get("exam/getExams", {
      Headers: apiHeader(),
      params: payload,
    });
    return res;
  };